<template>
    <div class="address">
        <div class="header" :class="$iosHeight()">
            <div class="headLeft">
                <div class="img" @click="onBack">
                    <img src="../../../assets/img/b2b/icon_back_white@2x.png" alt="">
                </div>
            </div>
            <div class="headCenter">领券中心</div>
            <div class="headRight"></div>
        </div>
        <div class="heightDiv" :class="$iosHeightDiv()"></div>
        <div class="main">
            <div>
                <img src="../../../assets/img/b2b/image@2x.png" alt="">
            </div>
            <div class="conputList" v-if="conputList.length">
                <div class="items" @click="onEffect(item)" v-for="(item,index) in conputList" :key="index">
                    <div class="itemLeft f64">
                        <span class="f36">¥</span>{{item.couponValue}}
                    </div>
                    <!-- hasDrawed是否领取过,canDraw现在是否可以领取,drawedRatio已领取的百分比,couponType:1:满减 2:无门槛 -->
                    <div class="itemRight" :class="[item.hasDrawed?'effectImg':'',item.canDraw?'':'effectImg2']">
                        <div class="title">
                            <h3 class="f28">{{item.couponName}}</h3>
                            <p class="col666"><span>{{item.effectiveStartDate|formatDate3}}-{{item.effectiveEndDate|formatDate3}}</span></p>
                            <p class="col666" v-if="item.couponType===1"><span>满{{item.reachAmount}}元使用</span></p>
                            <p class="col666" v-if="item.couponType===2"><span>无门槛</span></p>
                            <p class="col666">
                                <!--<span>指定类目参加</span>-->
                                <span v-if="item.joinType === 1">全场参加</span>
                                <span v-if="item.joinType === 2">指定类目</span>
                                <span v-if="item.joinType === 3">指定商品</span>
                            </p>
                        </div>
                        <div class="progree" v-if="item.canDraw">
                            <mt-progress :value="item.drawedRatio" :bar-height="4">
                                <div class="f24 col666 pro" slot="end">已领{{item.drawedRatio}}%</div>
                            </mt-progress>
                        </div>
                        <div class="btn" v-if="item.drawedRatio!==100&&item.canDraw" @click.stop="onDraw(item)">立即领取</div>
                        <!-- <div class="btn" v-if="item.hasDrawed">去使用</div> -->
                        <div class="btn btn2" v-if="item.drawedRatio===100||item.canDraw==false">立即领取</div>
                    </div>
                </div>
            </div>
            <div class="msg" v-else>
                <!-- <img src="../../../assets/img/b2b/img_empty_coupons@2x.png" alt=""> -->
                暂无优惠券
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant'
import { mapActions } from 'vuex'
export default {
    name: 'invoice',
    data () {
        return {
            title: '领券购物',
            titleRight: '',
            invoiceListId: '', // 判断是否选中
            userInfo: '',
            memberCode: '',
            couponCode: '',
            drawUserId: '',
            conputList: '',
            height: 0,
            scure: 0,
            invoiceList: [],
            selectAddressBack: '',
            organizationCode: ''
        }
    },
    methods: {
        ...mapActions(['getMyCouponListData', 'getDrawData']),
        onBack () {
            this.$router.go(-1)
        },
        getMyCoupon () {
            this.getMyCouponListData({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                this.conputList = data
            })
        },
        onDraw (item) {
            if (this.conputList.hasDrawed) {
                return false
            }
            this.getDrawData({
                memberCode: this.userInfo.companyCode,
                couponCode: item.couponCode,
                drawUserId: this.userInfo.id
            }).then((data) => {
                Toast('领取成功!')
                this.getMyCoupon()
            })
        },
        onEffect (item) {
            this.$router.push({ path: '/b2b/home/effect', query: { code: item.couponCode } })
        }
    },
    async mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (this.userInfo.belongMerchantCode) {
            await this.getMyCoupon()
        }
    }
}
</script>
<style lang="scss" scoped>
    .hTop{
        height: 88px !important;
    }
    .hTop64{
        height: 128px !important;
    }
    .hTop88{
        height: 176px !important;
    }
    .address {
        font-size: 28px;
        min-height: 100%;
        color: #000000;
        background-color: #FF7F2B;
        position: relative;
        .header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-between;
            height: 88px;
            line-height: 88px;
            z-index: 9;
            background: #ff9420;
            color: #ffffff;
            .headLeft {
                flex: 0 0 200px;
                .img {
                    width: 80px;
                    height: 80px;
                }
            }
            .headCenter {
                font-size: 36px;
            }
            .headRight {
                flex: 0 0 200px;
                text-align: right;
            }
        }
        .conputList{
            position: relative;
            top: -100px;
        }
        .msg{
            text-align: center;
            padding-top: 100px;
            color: #ffff;
        }
        .items{
            background: #ffffff;
            border-radius: 12px;
            margin-top: 20px;
            margin-left: 24px;
            margin-right: 24px;
            height: 224px;
            display: flex;
            justify-content: flex-start;
            h3{
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
            }
            .itemLeft{
                width: 224px;
                line-height: 224px;
                text-align: center;
                background: url(../../../assets/img/b2b/coupon.png) no-repeat;
                background-size: 100% 100%;
                font-family:SFUIDisplay-Bold;
                font-weight:bold;
                color:rgba(255,255,255,1);
                &.couponCopy{
                    background: url(../../../assets/img/b2b/couponCopy.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
            .itemRight{
                flex: 1;
                padding: 32px 28px 0;
                position: relative;
                .title{
                    p{
                        margin-top: 6px;
                        font-size: 22px;
                    }
                }
                .time{
                    font-size: 22px;
                    margin-top: 26px;
                    white-space: nowrap;
                    transform: scale(0.95);
                    transform-origin: 0 0 0;
                }
                .progree{
                    width: 246px;
                    .pro{
                        margin-left: 14px;
                        transform: scale(0.95);
                        height: 0px
                    }
                }
                .btn{
                    width: 144px;
                    height: 48px;
                    line-height: 48px;
                    text-align: center;
                    color: #ffffff;
                    border-radius: 48px;
                    font-size: 22px;
                    background: #FF834E;
                    position: absolute;
                    right: 16px;
                    bottom: 16px;
                    z-index: 9999;
                }
                .btn2{
                    background: #f5f5f5;
                    color: #c7c7c7;
                }
                &.effectImg{
                    background: url(../../../assets/img/b2b/img_user1.png) no-repeat;
                    background-size: 112px 96px;
                    background-position: 366px 0;
                }
                &.effectImg2{
                    background: url(../../../assets/img/b2b/img_user2.png) no-repeat;
                    background-size: 112px 96px;
                    background-position: 366px 0;
                }
            }
        }
        .mtop1{
            padding-top: 130px !important;
        }
        .mtop2{
            padding-top: 96px !important;
        }
    }
    /deep/ .mt-progress-runway, .mt-progress-progress{
        border-radius: 8px;
    }
    /deep/ .mt-progress-progress{
        background-color: #FF834E
    }
</style>
